const clientLogos = [
  { name: 'DETRAN-PB', src: '/assets/cliente-detran-pb.jpg' },
  { name: 'Governo da Paraíba', src: '/assets/cliente-governo-pb.png' },
  { name: 'AMAZUL', src: '/assets/cliente-amazul.jpg' },
  { name: 'CREA-BA', src: '/assets/cliente-crea-ba.jpg' },
  { name: 'Exército Brasileiro', src: '/assets/cliente-exercito.svg' },
];

const partnerLogos = [
  { name: 'GoldenTech', src: '/assets/parceiro-goldentech.png' },
  { name: 'Avell', src: '/assets/parceiro-avell.png' },
  { name: 'Concórdia', src: '/assets/parceiro-concordia.png' },
  { name: 'Positivo', src: '/assets/parceiro-positivo.png' },
  { name: 'Dell', src: '/assets/parceiro-dell.png' },
  { name: 'Lenovo', src: '/assets/parceiro-lenovo.png' },
  { name: 'Kaspersky', src: '/assets/parceiro-kaspersky.png' },
  { name: 'Brazil PC', src: '/assets/parceiro-brazilpc.png' },
];

function LogoCarousel({
  logos,
  reverse = false,
}: {
  logos: { name: string; src: string }[];
  reverse?: boolean;
}) {
  const carouselLogos = [...logos, ...logos];

  return (
    <div className="relative overflow-hidden">
      <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-white to-transparent" />

      <div className={`clients-carousel-track flex w-max items-center gap-8 md:gap-12 ${reverse ? 'clients-carousel-reverse' : ''}`}>
        {carouselLogos.map((item, index) => (
          <div
            key={`${item.name}-${index}`}
            className="flex h-28 w-[260px] shrink-0 items-center justify-center rounded-lg border border-gray-100 bg-white px-6 shadow-[0_10px_30px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-donnos-green/30 hover:shadow-[0_16px_36px_rgba(15,23,42,0.10)]"
            title={item.name}
          >
            <img
              src={item.src}
              alt={item.name}
              className="max-h-20 max-w-full object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ClientsSection() {
  return (
    <section className="py-14 md:py-20 bg-white overflow-hidden">
      <div className="w-full space-y-14">
        <div>
          <div className="px-4 md:px-8 lg:px-12 text-center mb-8">
            <h2 className="text-sm font-extrabold text-donnos-green uppercase tracking-wider mb-2">
              NOSSOS CLIENTES
            </h2>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-950">
              Empresas e instituições que confiam na Donnos
            </h3>
          </div>
          <LogoCarousel logos={clientLogos} />
        </div>

        <div>
          <div className="px-4 md:px-8 lg:px-12 text-center mb-8">
            <h2 className="text-sm font-extrabold text-donnos-green uppercase tracking-wider mb-2">
              NOSSOS PARCEIROS
            </h2>
            <h3 className="text-2xl md:text-3xl font-extrabold text-gray-950">
              Marcas parceiras para soluções completas
            </h3>
          </div>
          <LogoCarousel logos={partnerLogos} reverse />
        </div>
      </div>
    </section>
  );
}
